<template>
  <div>
    <div class="header-div custom-shape-divider-top-1664458927">
      <svg
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1200 120"
        preserveAspectRatio="none"
      >
        <path
          d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z"
          opacity=".25"
          class="shape-fill"
        ></path>
        <path
          d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z"
          opacity=".5"
          class="shape-fill"
        ></path>
        <path
          d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z"
          class="shape-fill"
        ></path>
      </svg>
    </div>
    <v-container>
      <v-row class="py-10 px-4 top-label mb-3 text-white">Please create an acount first by sign-up and then sign-in to access employee list for adding, updating or deleting enployees</v-row>
      <!-- Admin List -->
      <v-row>
        <v-col lg="5" sm="12">
          <h1>Admin Panel</h1>
          <div>
            <!-- Sign Up -->
            <v-form
              ref="admin"
              v-model="valid"
              lazy-validation
              v-show="showAdmin"
            >
              <v-container>
                <h3 class="mb-3 text-amber">Sign Up</h3>
                <v-text-field
                  v-model="adminData.firstname"
                  :rules="nameRules"
                  :counter="10"
                  label="First name"
                  required
                ></v-text-field>

                <v-text-field
                  v-model="adminData.lastname"
                  :rules="nameRules"
                  :counter="10"
                  label="Last name"
                  required
                ></v-text-field>

                <v-text-field
                  v-model="adminData.email"
                  :rules="emailRules"
                  label="E-mail"
                  required
                ></v-text-field>

                <v-text-field
                  v-model="adminData.phoneNumber"
                  :rules="phoneRules"
                  :counter="13"
                  label="Phone Number"
                  required
                ></v-text-field>

                <v-text-field
                  v-model="adminData.password"
                  :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="[rules.required, rules.min]"
                  :type="show2 ? 'text' : 'password'"
                  name="input-10-2"
                  label="Password"
                  hint="At least 4 characters"
                  class="input-group--focused"
                  @click:append="show2 = !show2"
                ></v-text-field>

                <v-btn
                  :disabled="!valid"
                  color="success"
                  class="mr-2"
                  @click="submitNewAdmin"
                >
                  Add Admin
                </v-btn>

                <v-btn color="error" class="mr-2" @click="resetAdmin">
                  Reset Form
                </v-btn>

                <v-btn color="secondary" class="mr-2" @click="signUpAdmin">
                  Sign In
                </v-btn>

                <v-btn color="info" class="" @click="signOutAdmin">
                  <v-icon>mdi-logout</v-icon>
                </v-btn>
              </v-container>
            </v-form>

            <!-- Sign In -->
            <v-form
              ref="adminSignIn"
              v-model="valid"
              lazy-validation
              v-show="!showAdmin"
            >
              <v-container>
                <h3 class="mb-3 text-amber">Sign In</h3>
                <v-text-field
                  v-model="adminSignIn.email"
                  :rules="emailRules"
                  label="E-mail"
                  required
                ></v-text-field>

                <v-text-field
                  v-model="adminSignIn.password"
                  :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="[rules.required, rules.min, rules.emailMatch]"
                  :type="show2 ? 'text' : 'password'"
                  name="input-10-2"
                  label="PasswordS"
                  hint="At least 4 characters"
                  class="input-group--focused"
                  @click:append="show2 = !show2"
                ></v-text-field>
                <p class="text-error" v-show="showError">
                  Email Or Password Didn't Matched
                </p>
                <v-btn
                  :disabled="!valid"
                  color="success"
                  class="mr-4"
                  @click="submitAdmin"
                >
                  Submit
                </v-btn>

                <v-btn color="error" class="mr-4" @click="resetAdminSignIn">
                  Reset Form
                </v-btn>

                <v-btn color="secondary" class="mr-4" @click="signUpAdmin">
                  Sign Up
                </v-btn>

                <v-btn color="info" @click="signOutAdmin" >
                  <v-icon>mdi-logout</v-icon>
                </v-btn>
              </v-container>
            </v-form>
          </div>
        </v-col>
        <v-col lg="7" sm="12" v-show="$store.state.adminLoggedIn">
          <h1>Admin List</h1>
          <v-container class="my-5">
            <v-card flat v-for="item in $store.state.adminList" :key="item.id">
              <v-layout row wrap :class="`pa-3 layout-${item.random}`">
                <div xs12 md6 class="me-5">
                  <div class="text-h6 font-weight-bold">FirstName</div>
                  <div class="text-capitalize">{{ item.firstName }}</div>
                </div>
                <div xs12 md6 class="me-5">
                  <div class="text-h6 font-weight-bold">LastName</div>
                  <div class="text-capitalize">{{ item.lastName }}</div>
                </div>
                <div xs6 sm4 md2 class="me-5">
                  <div class="text-h6 font-weight-bold">Email</div>
                  <div>{{ item.email }}</div>
                </div>
                <div xs6 sm4 md2 class="me-5">
                  <div class="text-h6 font-weight-bold">Phone</div>
                  <div>{{ item.phone }}</div>
                </div>
                <div xs6 sm4 md2 class="me-5">
                  <div class="text-h6 font-weight-bold">Password</div>
                  <div>{{ item.password }}</div>
                </div>
              </v-layout>
              <v-divider></v-divider>
            </v-card>
          </v-container>
        </v-col>
      </v-row>

      <!-- Employee List -->
      <v-row class="mt-6" v-show="$store.state.adminLoggedIn">
        <v-col lg="5" sm="12">
          <h1>Add New Employee</h1>
          <div>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-container>
                <v-text-field
                  v-model="userData.firstname"
                  :rules="nameRules"
                  :counter="10"
                  label="First name"
                  required
                ></v-text-field>

                <v-text-field
                  v-model="userData.lastname"
                  :rules="nameRules"
                  :counter="10"
                  label="Last name"
                  required
                ></v-text-field>

                <v-text-field
                  v-model="userData.email"
                  :rules="emailRules"
                  label="E-mail"
                  required
                ></v-text-field>

                <v-text-field
                  v-model="userData.phoneNumber"
                  :rules="phoneRules"
                  :counter="13"
                  label="Phone Number"
                  required
                ></v-text-field>
                <v-btn
                v-show="!editUser"
                  :disabled="!valid"
                  color="success"
                  class="mr-4"
                  @click="validate"
                >
                  Add Employee
                </v-btn>
                <v-btn
                  v-show="editUser"
                  :disabled="!valid"
                  color="success"
                  class="mr-4"
                  @click="updateUser"
                >
                  Edit Employee
                </v-btn>
                <v-btn color="error" class="mr-4" @click="reset">
                  Reset Form
                </v-btn>
              </v-container>
            </v-form>
          </div>
        </v-col>
        <v-col lg="7" sm="12">
          <h1>Employee List</h1>
          <v-container class="my-5">
            <v-card flat v-for="item in $store.state.items" :key="item.id">
              <v-layout row wrap :class="`pa-3 layout-${item.random}`">
                <div xs12 md6 class="me-5">
                  <div class="text-h6 font-weight-bold">FirstName</div>
                  <div class="text-capitalize">{{ item.firstName }}</div>
                </div>
                <div xs12 md6 class="me-5">
                  <div class="text-h6 font-weight-bold">LastName</div>
                  <div class="text-capitalize">{{ item.lastName }}</div>
                </div>
                <div xs6 sm4 md2 class="me-5">
                  <div class="text-h6 font-weight-bold">Email</div>
                  <div>{{ item.email }}</div>
                </div>
                <div xs6 sm4 md2 class="me-5">
                  <div class="text-h6 font-weight-bold">Phone</div>
                  <div>{{ item.phone }}</div>
                </div>
                <v-spacer></v-spacer>

                <v-row justify="center">
                  <v-dialog v-model="dialog" persistent>
                    <template v-slot:activator="{ props }">
                      <v-btn
                        v-bind="props"
                        color="error mr-3 my-auto"
                        icon="mdi-delete"
                        size="small"
                        @click="selectDelete = item"
                      >
                      </v-btn>
                    </template>
                    <v-card class="w-25 mx-auto">
                      <v-card-title class="text-h5">
                        Action Confirmation
                      </v-card-title>
                      <v-card-text>
                        Are willing to remove this Employee?
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green" @click="dialog = false">
                          Cancel
                        </v-btn>
                        <v-btn color="red" @click="deleteUser(selectDelete)">
                          Delete
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-row>

                <v-btn
                  color="success my-auto"
                  icon="mdi-pencil"
                  size="small"
                  @click="selectUpdateUser(item)"
                ></v-btn>
              </v-layout>
              <v-divider></v-divider>
            </v-card>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  data: () => ({
    valid: true,
    showError: false,
    selectDelete: null,
    adminSignIn: {
      email: "",
      password: "",
    },
    adminData: {
      firstname: "",
      lastname: "",
      email: "",
      phoneNumber: "",
      password: "",
    },
    showAdmin: false,
    userData: {
      firstname: "",
      lastname: "",
      email: "",
      phoneNumber: "",
    },
    nameRules: [
      (v) => !! v || "Name is required",
      (v) => v.length <= 10 || "Name must be less than 10 characters",
    ],
    emailRules: [
      (v) => !! v || "E-mail is required",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
    phoneRules: [
      (v) => !!v || "Phone Number is required",
      (v) => v.length <= 11 || "Phone Number must be less than 11 characters",
      (v) =>
        // (
        //   /^\+?([0-9]{2})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{8})$/ |
        //   /^([0-9]{3})[-. ]?([0-9]{8})$/
        // )
        /^([0-9]{3})([0-9]{8})$/.test(v) || "Phone Number must be valid",
    ],
    show2: false,
    password: "Password",
    rules: {
      required: (value) => !!value || "Required.",
      min: (v) => v.length >= 4 || "Min 4 characters",
    },
    dialog: false,
    editUser: false,
  }),
  methods: {
    submitAdmin() {
      this.$store.dispatch("signInAdmin", this.adminSignIn);
      
      if (!this.$store.state.adminLoggedIn) {
        this.showError = true;
      } else {
        this.showAdmin = !this.showAdmin;
        this.showError = false;
      }
    },
    submitNewAdmin() {
      this.$store.dispatch("addNewAdmin", this.adminData)
      // this.adminData.firstname = ""
      // this.adminData.lastname = ""
      // this.adminData.email = ""
      // this.adminData.phoneNumber = ""
      // this.adminData.password = ""
      this.showAdmin = false
    },
    resetAdmin() {
      this.$refs.admin.reset();
    },
    resetAdminSignIn() {
      this.$refs.adminSignIn.reset();
    },
    signUpAdmin() {
      this.showAdmin = !this.showAdmin;
    },
    signOutAdmin() {
      this.$store.state.adminLoggedIn = false;
    },
    validate() {
      this.$refs.form.validate();
      this.$store.dispatch("addNewUser", this.userData);
    },
    reset() {
      this.$refs.form.reset();
    },
    deleteUser(item) {
      this.dialog = false;
      this.$store.dispatch("deleteUser", item);
    },
    selectUpdateUser(item){
      this.editUser = true;
      this.userData = {
        id: item.id,
        firstname: item.firstName,
        lastname: item.lastName,
        email: item.email,
        phoneNumber: item.phone,
      };
    },
    updateUser() {
      this.$store.dispatch("editUser", this.userData);
      this.editUser = false
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Noto+Sans+Mono:wght@600&family=Righteous&display=swap");

h1 {
  font-family: "Righteous", cursive;
}
h3 {
  font-family: "Noto Sans Mono", monospace;
}
.header-div {
  /* height: 100vh; */
}
.custom-shape-divider-top-1664458927 {
  width: 100%;
  overflow: hidden;
  line-height: 0;
  margin-top: -64px;
}

.custom-shape-divider-top-1664458927 svg {
  position: relative;
  display: block;
  width: calc(110% + 1.3px);
  height: 365px;
  transform: rotateY(180deg);
}

.custom-shape-divider-top-1664458927 .shape-fill {
  fill: #442697;
}
.top-label{
  border-left: 8px solid #ffaa2c;
  border-radius: 5px;
  background-color: rgb(255, 170, 44, 0.6);
}
.layout-1 {
  border-left: 4px solid #3cd1c2;
}
.layout-2 {
  border-left: 4px solid #ffaa2c;
}
.layout-3 {
  border-left: 4px solid #f83e70;
}
</style>